import { createSelector } from 'reselect';
import { getReferenceDataCriteriaArguments } from '../../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import StaticCriteriaArguments from './static-criteria-arguments';

const getCriteriaArguments = createSelector(
  (state) => getReferenceDataCriteriaArguments(state),
  (state) => StaticCriteriaArguments(state),
  (referenceDataCriteriaArguments, staticCriterionArguments) => ({
    ...referenceDataCriteriaArguments,
    ...staticCriterionArguments,
  }),
);

export default getCriteriaArguments;
